import { TextField } from '@/components/design-system'

interface FormData {
  name: string
  description: string
  plan_rank: string
  daily_token_limit: string
  daily_budget_usd: string
}

interface FormErrors {
  name?: string
  description?: string
  plan_rank?: string
  daily_token_limit?: string
  daily_budget_usd?: string
}

interface Props {
  data: FormData
  errors: FormErrors
  setData: (key: keyof FormData, value: string) => void
}

export default function TokenPlanFormFields({ data, errors, setData }: Props) {
  return (
    <div className="space-y-4">
      <TextField
        label="Nome"
        value={data.name}
        onChange={(value) => setData('name', value)}
        error={errors.name}
      />
      <TextField
        label="Descrição"
        value={data.description}
        onChange={(value) => setData('description', value)}
        error={errors.description}
        helpText="Texto exibido no seletor de planos da aba Uso. Deixe vazio para usar o texto genérico."
        multiline={3}
      />
      <TextField
        label="Ranking"
        type="number"
        value={data.plan_rank}
        onChange={(value) => setData('plan_rank', value)}
        error={errors.plan_rank}
        helpText="Define a hierarquia do plano. Maior ranking = plano superior."
      />
      <TextField
        label="Limite Diário de Tokens"
        type="number"
        value={data.daily_token_limit}
        onChange={(value) => setData('daily_token_limit', value)}
        error={errors.daily_token_limit}
        helpText="Deixe vazio para ilimitado."
      />
      <TextField
        label="Budget Diário USD"
        type="number"
        value={data.daily_budget_usd}
        onChange={(value) => setData('daily_budget_usd', value)}
        error={errors.daily_budget_usd}
        helpText="Deixe vazio para não aplicar cap no LiteLLM."
      />
    </div>
  )
}
